import React, { useEffect } from "react";

import column from "../../Images/Vector (9).png";
import grid from "../../Images/Group 1171279337.png";
import grid2 from "../../Images/Group 1171279337 (1).png";
import dropdown from "../../Images/Vector (8).png";
import { useState } from "react";

import PropertyTable from "../PropertyList/PropertyTable.jsx";
import PropertyGrid from "../PropertyList/PropertyGrid.jsx";
import PropertyColumn from "../PropertyList/PropertyColumn.jsx";
import Header from "../../Layout/Header.jsx";
import image from "../../Images/Rectangle 20 (1).png";
import whatsapp from "../../Images/Group 534.png";
import arrow2 from "../../Images/Vector (11).png";
import heart from "../../Images/Vector (10).png";
import redHeart from "../../Images/red-heart.png";
import plus from "../../Images/Vector@2x.png";
import HomeService from "../../Services/HomeService.js";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../Layout/Sidebar.jsx";
import { toast } from "react-toastify";

const CommunityFavList = ({ setShowInner }) => {
  const [progress, setProgress] = useState(0);
  const [toggle, settoggle] = useState(1);
  const [index, SetIndex] = useState();
  const [userId, setUserId] = useState("");
  const [allAdvertisement, setAllAdvertisement] = useState([]);

  const navigate = useNavigate();
  const handleInputChange = (event) => {
    const value = event.target.value;
    setProgress(value);
  };

  const handleNavigateDealer = (dealerDetails) => {
    console.log("NJU36", dealerDetails);

    // e.preventDefault();
    setShowInner(false);

    navigate("/community-fav-list", { state: { dealerDetails } });
  };

  const fetchAllAdvertisement = async () => {
    try {
      // const res = await HomeService.getAllAdvertisement();
      const res = await HomeService.getFavCommunities();
      console.log("VBZ46", res.data);

      if (res?.status) {
        // setAllAdvertisement(res.data.sort((d1, d2) => new Date(d1.createdOn) - new Date(d2.createdOn)));
        setAllAdvertisement(res.data.filter((item) => item?.communityUser));
      } else {
        setAllAdvertisement([]);
      }
    } catch (error) {
      console.log("Error fetching users data", error);
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  useEffect(() => {
    fetchAllAdvertisement();
    // console.log("all advertisement data", allAdvertisement);
  }, []);

  useEffect(() => {
    const fetchLoginProfile = async () => {
      const response = await HomeService.getLoginProfile();
      // console.log("this is login profile response", response);
      if (!response.status) {
        navigate("/profile");
      }
      if (response?.status) {
        setUserId(response?.data?._id);
      }
    };
    fetchLoginProfile();
  }, [userId]);

  const handleFavourite = async (e, id) => {
    e.preventDefault();
    console.log("LKL85", id);

    try {
      const res = await HomeService.makeFavouriteCommunity({
        communityUserId: id,
      });

      if (res?.status) {
        toast.success(res?.message);
        fetchAllAdvertisement();
      } else {
        toast.error(toast.message);
      }
    } catch (error) {
      // toast.error("Failed to add property.");
      console.error("Error adding favourite:", error);
    }
  };

  return (
    <>
      <>
        <Header />

        <Sidebar />
        <div
          className="uni_wrapper bg"
          // style={{
          //   display: 'flex',
          //   justifyContent: 'center',

          // }}
        >
          <div
            className="uni_container5"
            style={{
              padding: "20px",
            }}
            // style={{
            //   width: '100%',
            //   maxWidth: '80%',
            //   minWidth: '80%'
            // }}
          >
            <div
              className="property_grid_div5"
              style={{
                width: "100%",
                maxWidth: "80%",
                minWidth: "80%",
              }}
            >
              {allAdvertisement.map((e, i) => {
                return (
                  <>
                    <div
                      className="property_grid_two"
                      key={i}
                      onClick={() => {
                        handleNavigateDealer(e?.communityUser);
                      }}
                    >
                      <div className="propety_grid_img new_property_grid_img">
                        <img
                          className="propety_grid_img_display  new_propety_grid_img_display"
                          src={e?.communityUser?.image}
                          alt="dealer"
                        />
                        <div
                          className="heart_div_2"
                          style={{ cursor: "pointer" }}
                          onClick={(i) => {
                            i.stopPropagation();
                            handleFavourite(i, e?.communityUser?._id);
                          }}
                        >
                          <img src={redHeart}></img>
                        </div>
                      </div>
                      <div className="property_grid_data new_property_grid_data d-flex justify-content-between align-items-center flex-column">
                        <div className="property_grid_content">
                          <div className="property_data property_data_new_class">
                            <div className="property_para_div">
                              <p className="property_data_para">Name:</p>
                              <p className="property_data_para2">
                                {e?.communityUser?.fullName}
                              </p>
                            </div>

                            <div className="property_para_div">
                              <p className="property_data_para">
                                Business Field:
                              </p>
                              <p className="property_data_para2">
                                {e?.communityUser?.businessField}
                                {/* {e?.businessField
                                  ?.map((field) => field.name)
                                  .join(", ")} */}
                              </p>
                            </div>

                            <div className="property_para_div">
                              <p className="property_data_para">
                                Major Locality:
                              </p>
                              <p className="property_data_para2">
                                {e?.communityUser?.majorLocality}
                              </p>
                            </div>

                            <div className="property_para_div">
                              <p className="property_data_para">
                                Working Experience:
                              </p>
                              <p className="property_data_para2">
                                {e?.communityUser?.workExpYear}
                              </p>
                            </div>
                          </div>
                        </div>

                        {userId === e?.communityUser?.userId ? (
                          <div className="remark_button_wrapper_div">
                            <div className="submit_btn_icon_wrapper new_submit_btn_icon_wrapper">
                              <button
                                onClick={() => {
                                  handleNavigateDealer(e);
                                }}
                              >
                                Fill Requirement
                              </button>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {/* <div className="plus_div_icon">
                        <img src={plus}></img>
                      </div> */}
                    </div>
                  </>
                );
              })}
              {allAdvertisement.length === 0 && (
                <>No favourite communities found!</>
              )}
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default CommunityFavList;
